<template>

    <div class="container card p-5 shadow w-100">
        
        <h1>Edit TestType </h1>
        <hr>
        
        <div v-if="response.success != null" v-bind:class="{ 'alert-success': response.success, 'alert-danger': !response.success }" class="alert" role="alert">
            {{response.message}}
        </div>

        <div id="form">
            <div class="input-group mb-3">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-lg">Title</span>
                </div>
                <input v-model="testType.title" type="text" class="form-control" placeholder="Enter Title">
            </div>
            <button @click="editTestType()" type="button" class="btn btn-primary mb-3">Edit TestType</button>
        </div>
    </div>

</template>

<script>
export default {
    data() {
        return {
            testType: {
                title: null,
                id: null
            },
            response: {},
        }
    },
    methods: {
        editTestType: function(){
            
            let self = this;
            this.$http.put('/api/test-types/edit/', this.testType)
            .then(response => {
                self.response = response.data;
            })
            .catch(error => {
                console.log(error);
            })
            
        },
        loadCurrentTestType: function() {
            let self = this;
            this.$http.get('/api/test-types/get/' + this.$route.params.id)
            .then(response => {
                self.testType = response.data;
                self.initialKey = response.data.titleTranslationKey;
            })
            .catch(error => {
                console.log(error);
                self.$router.push("/404");
            })
        },
    },
    mounted: function() {
        this.testType.id = this.$route.params.id;
        this.loadCurrentTestType();
    },
    watch: {
        response: function(val){
            if(val.success === true){
                setTimeout(() => {
                    this.$router.push("/admin/test-types/");
                }, 1000)
            }
            setTimeout(() => {
                this.response.success = null;
            }, 3000) 
        },
    }
    
}
</script>

<style lang="scss">
.autocomplete{
  position: relative;
  display: inline-block;
}
input{
  border: 1px solid transparent;
  background-color: #f1f1f1;
  padding: 10px;
  font-size: 16px;
  &[type=text]
  {
    width: 100%;
  }
}

.autocomplete-items
{
  position: absolute;
  border: 1px solid #d4d4d4;
  border-bottom: none;
  border-top: none;
  z-index: 99;
  top: 100%;
  left: 0;
  right: 0;
  input{
    padding: 10px;
    cursor: pointer;
    background-color: #fff;
    border-bottom: 1px solid #d4d4d4;
    &:hover{
      background-color: #e9e9e9;
    }
  }
}
.autocomplete-active{
  background-color: DodgerBlue !important;
  color: #ffffff;
}


div{
    span.input-group-text {
        width: 85px;
    }
}

.form-control[readonly] {
    background-color: white;
}
</style>
